import { useEffect } from 'react';

export function useJsonLd(id: string, data: unknown) {
  const json = data == null ? '' : JSON.stringify(data);

  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    if (!json) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = json;
    document.head.appendChild(script);

    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, json]);
}